export const INCREMENT = 'increment'; 
export const  UPDATEUSER = 'updateUser';
export const UPDATETOKEN = 'updateToken';
